import { render, staticRenderFns } from "./ProjectDepartment.vue?vue&type=template&id=28bbdeed"
import script from "./ProjectDepartment.vue?vue&type=script&lang=js"
export * from "./ProjectDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports